var CONFUSEDCMS = CONFUSEDCMS || {};
CONFUSEDCMS.CONSTANTS = CONFUSEDCMS.CONSTANTS || {};

CONFUSEDCMS.CONSTANTS.breakdownConstants = (function () {

    return {
        containerClass: ".breakdown-promo",
        stepNames: {
            InitialisingSpinner: "Initialising-Spinner",
            CoverSavedVehicles: "Cover-SavedVehicles",
            CoverNewReg: "Cover-NewReg",
            CoverDuration: "Cover-Duration",
            CoverTripType: "Cover-TripType",
            Spinner: "Results-Spinner",
            Prices: "Results-Prices",
            ErrorPage: "Results-Error",
            NoPrices: "Results-NoPrices",
        },
        resultsPagePanelSelector: ".breakdown-results-panel",
        resultsPageLocalProductImageSelector: ".results-page-local",
        resultsPageNationalProductImageSelector: ".results-page-national",
        resultsPageEuropeanProductImageSelector: ".results-page-european",
        resultsProductTypeLocalClass: "breakdown-results-panel--active-1",
        resultsProductTypeNationalClass: "breakdown-results-panel--active-2",
        resultsProductTypeEuropeanClass: "breakdown-results-panel--active-3",
        resultsPageHeadingSelector: ".results-heading",
        resultsPageSelector: ".breakdown-results",
        resultsPageHeadingLocalWordingDataAttr: "localWording",
        resultsPageHeadingNationalWordingDataAttr: "nationalWording",
        resultsPageHeadingEuroAnnualWordingDataAttr: "euroAnnualWording",
        resultsPageHeadingEuroSingleWordingDataAttr: "euroSingleWording",
        resultsPageSelectedProductClass: "breakdown-widget-image-button--active"
};

}());